// extracted by css-extract-rspack-plugin
export default {"container":"kahDD37R6csvh2Ok","button":"fUuDNcaK7r4zolyx","content":"T7wmqH6qlNwnFsaq","expandable":"Ytn3mfJoIskrgkoK","icon":"trGbIBIKq5wbO8Dy","open":"r2AYJsNy5G4P3ftd"};